
import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const CafePerformance = ({ data }) => {
  return (
    <div className="bg-white rounded-lg shadow p-6">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-medium text-gray-900">Cafe Amazon Performance</h3>
        <button className="text-sm text-purple-700 hover:text-purple-900">View Details</button>
      </div>
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="#E0E0E0" />
            <XAxis dataKey="month" tick={{ fill: '#424242' }} />
            <YAxis tick={{ fill: '#424242' }} />
            <Tooltip 
              contentStyle={{ 
                backgroundColor: '#fff',
                border: '1px solid #E0E0E0',
                borderRadius: '4px'
              }} 
            />
            <Line 
              type="monotone" 
              dataKey="cups" 
              stroke="#34C759" 
              strokeWidth={2} 
              dot={{ r: 4, fill: '#34C759' }}
              name="Monthly Cups (M)"
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
      <div className="mt-2 flex justify-between text-sm">
        <div className="text-center">
          <p className="text-gray-500">Total Outlets</p>
          <p className="font-semibold text-gray-800">4,462</p>
        </div>
        <div className="text-center">
          <p className="text-gray-500">YoY Growth</p>
          <p className="font-semibold text-green-600">+8.4%</p>
        </div>
        <div className="text-center">
          <p className="text-gray-500">Annual Cups</p>
          <p className="font-semibold text-gray-800">402M</p>
        </div>
      </div>
    </div>
  );
};

export default CafePerformance;
